/* eslint-disable @typescript-eslint/no-explicit-any */
// Si quelqu'un trouve comment éviter les "any" dans ce fichier, je suis preneur!
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { AdressePhysiqueCredit } from 'src/app/api/model/adresse-physique-credit.model';
import { TranslateService } from '@ngx-translate/core';
import { AdressePhysiqueBancaire } from 'src/app/api/model/adresse-physique-bancaire.model';
import { AdressePostdateeBancaire } from 'src/app/api/model/adresse-postdatee-bancaire.model';
import { ADRESSE_VALIDATION_CONFIG } from 'src/app/validators/adresse-validation-config.validators';
import { CybermetrieCoordonneesService } from '../../../services/cybermetrie/cybermetrie.service';
import { ConfigDsdAdresseService } from '../../../services/config-dsd-adresse.service';

@Component({
  selector: 'app-modification-adresse',
  templateUrl: './modification-adresse.component.html',
  styleUrls: ['./modification-adresse.component.scss'],
  standalone: false,
})
export class ModificationAdresseComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() isBancaire: boolean;
  @Input() adresseCourante: AdressePhysiqueCredit | AdressePhysiqueBancaire;
  @Input() adressePostDatee: AdressePostdateeBancaire;
  identifiantProjetPosteCanada: string;

  adresseCityRef: HTMLDsdInputElement;
  adresseProvinceRef: HTMLDsdSelectElement;
  adressePcRef: HTMLDsdInputElement;
  adresseStreetRef: HTMLDsdInputElement;
  adresseUnitRef: HTMLDsdInputElement;
  adresseCountryRef: HTMLDsdInputElement;

  cleTraductionErreurRueVide = 'formulairePosteCanada.coordonnees.rue.erreur.required';
  cleTraductionErreurVilleVide = 'formulairePosteCanada.coordonnees.ville.erreur.required';
  cleTraductionErreurPcVide = 'formulairePosteCanada.coordonnees.codePostal.erreur.required';
  cleTraductionErreurRueValide = 'formulairePosteCanada.coordonnees.rue.erreur.authorizedCharacters';
  cleTraductionErreurAppartementValide = 'formulairePosteCanada.coordonnees.appartement.erreur.appartement';
  cleTraductionErreurVilleValide = 'formulairePosteCanada.coordonnees.ville.erreur.ville';
  cleTraductionErreurPcValide = 'formulairePosteCanada.coordonnees.codePostal.erreur.codepostal';

  messageErreurRueVide: string = '';
  messageErreurVilleVide: string = '';
  messageErreurPcVide: string = '';
  messageErreurRueValide: string = '';
  messageErreurAppartementValide: string = '';
  messageErreurVilleValide: string = '';
  messageErreurPcValide: string = '';
  dateMin: string;
  dateMax: string;
  champsInitialises: boolean = false;
  configAdresse: any;

  constructor(
    private readonly translateService: TranslateService,
    private readonly cybermetrieCoordonneesService: CybermetrieCoordonneesService,
    private readonly configDsdAdresseService: ConfigDsdAdresseService
  ) {}

  ngOnInit(): void {
    this.initTraductions();
    this.preRemplirAdressePostdatee();
    this.definirPlageDate();
    if (this.isBancaire) {
      this.initValidationsAdresse();
    }
    this.configAdresse = this.isBancaire
      ? this.configDsdAdresseService.getConfigAdresseBancaire()
      : this.configDsdAdresseService.getConfigAdresse();
  }

  private initTraductions(): void {
    this.translateService
      .get(this.cleTraductionErreurRueVide)
      .subscribe((texte: string) => (this.messageErreurRueVide = texte));
    this.translateService
      .get(this.cleTraductionErreurVilleVide)
      .subscribe((texte: string) => (this.messageErreurVilleVide = texte));
    this.translateService
      .get(this.cleTraductionErreurPcVide)
      .subscribe((texte: string) => (this.messageErreurPcVide = texte));
    this.translateService
      .get(this.cleTraductionErreurRueValide)
      .subscribe((texte: string) => (this.messageErreurRueValide = texte));
    this.translateService
      .get(this.cleTraductionErreurAppartementValide)
      .subscribe((texte: string) => (this.messageErreurAppartementValide = texte));
    this.translateService
      .get(this.cleTraductionErreurVilleValide)
      .subscribe((texte: string) => (this.messageErreurVilleValide = texte));
    this.translateService
      .get(this.cleTraductionErreurPcValide)
      .subscribe((texte: string) => (this.messageErreurPcValide = texte));
  }

  public initValidationsAdresse(): void {
    this.formGroup.get('codePays')?.valueChanges.subscribe((pays: string) => {
      this.appliquerValidationChampAdresse('codePostal', pays);
      this.appliquerValidationChampAdresse('province', pays);
      this.appliquerValidationChampAdresse('ville', pays);
    });
    const paysInitial = this.formGroup.get('codePays')?.value;
    this.appliquerValidationChampAdresse('codePostal', paysInitial);
    this.appliquerValidationChampAdresse('province', paysInitial);
    this.appliquerValidationChampAdresse('ville', paysInitial);
  }

  private appliquerValidationChampAdresse(champ: 'codePostal' | 'province' | 'ville', pays: string): void {
    type PaysKey = 'ca' | 'us' | 'mx' | 'autre';
    const paysKey = (pays ?? '').toLowerCase() as PaysKey;
    const config = ADRESSE_VALIDATION_CONFIG[paysKey] ?? ADRESSE_VALIDATION_CONFIG.autre;
    const ctrl = this.formGroup.get(champ);
    if (!ctrl) return;
    ctrl.clearValidators();
    ctrl.setValidators(config[champ]);
    ctrl.updateValueAndValidity();
  }

  get libelleAdresseActuelle(): string {
    return this.isBancaire ? 'caad.modifier-coordonnees.adresse.actuelle' : 'caad.modifier-fiserv.coordonnees.actuel';
  }

  get libelleNouvelleAdresse(): string {
    return this.isBancaire
      ? 'caad.modifier-coordonnees.adresse.nouvelle'
      : 'caad.modifier-fiserv.coordonnees.nouvelleAdresse';
  }

  public onAddressReady($eventAdresse: any): void {
    if (this.isBancaire) {
      this.adresseCountryRef = $eventAdresse.detail.elements[
        $eventAdresse.detail?.name + '-country'
      ] as HTMLDsdInputElement;
      // Pré-remplir les inputs avec la valeur du formGroup si elle existe, sinon avec l'event
      const countryElement = $eventAdresse.detail.elements[$eventAdresse.detail.name + '-country'];
      this.adresseCountryRef.value = this.formGroup.get('codePays')?.value || this.adresseCountryRef.value;
      countryElement.addEventListener('dsdComboboxChange', () => {
        this.champsInitialises = false;
      });
    } else {
      this.setAdresseValidation($eventAdresse);
    }
  }

  public setAdresseValidation($eventAdresse: any): void {
    const name = $eventAdresse.detail?.name;

    this.adresseCityRef = $eventAdresse.detail.elements[name + '-city'] as HTMLDsdInputElement;
    this.adresseProvinceRef = $eventAdresse.detail.elements[name + '-province'] as HTMLDsdSelectElement;
    this.adressePcRef = $eventAdresse.detail.elements[name + '-pc'] as HTMLDsdInputElement;
    this.adresseStreetRef = $eventAdresse.detail.elements[name + '-street'] as HTMLDsdInputElement;
    this.adresseUnitRef = $eventAdresse.detail.elements[name + '-unit'] as HTMLDsdInputElement;

    // Pré-remplir les inputs avec la valeur du formGroup si elle existe, sinon avec l'event
    if (this.isBancaire) {
      this.adresseStreetRef.value = this.formGroup.get('numeroCiviqueNomRue')?.value || this.adresseStreetRef.value;
    } else {
      this.adresseStreetRef.value = this.formGroup.get('rue')?.value || this.adresseStreetRef.value;
    }
    this.adresseCityRef.value = this.formGroup.get('ville')?.value || this.adresseCityRef.value;
    this.adresseUnitRef.value = this.formGroup.get('appartement')?.value || this.adresseUnitRef.value;
    this.adressePcRef.value = this.formGroup.get('codePostal')?.value || this.adressePcRef.value;
    this.adresseProvinceRef.value = this.formGroup.get('province')?.value || this.adresseProvinceRef.value;

    if (this.isBancaire) {
      this.hookControlToEventChange(
        this.formGroup.get('numeroCiviqueNomRue'),
        this.adresseStreetRef,
        this.messageErreurRueVide
      );
    } else {
      this.hookControlToEventChange(this.formGroup.get('rue'), this.adresseStreetRef, this.messageErreurRueVide);
    }
    this.hookControlToEventChange(this.formGroup.get('ville'), this.adresseCityRef, this.messageErreurVilleVide);
    this.hookControlToEventChange(this.formGroup.get('appartement'), this.adresseUnitRef);
    this.hookControlToEventChange(this.formGroup.get('codePostal'), this.adressePcRef, this.messageErreurPcVide);
    this.hookControlToEventChange(this.formGroup.get('province'), this.adresseProvinceRef);
    this.setValidationsPourChampsAdresse();
  }

  private setValidationsPourChampsAdresse() {
    // Initialiser le message par défaut du code postal, car le message initial pour le code postal ne correspond pas au DCR
    this.adressePcRef.querySelector('span[slot="error"]').textContent = this.messageErreurPcVide;

    this.adresseStreetRef.registerCustomValidate(() => {
      const control = this.isBancaire ? this.formGroup.controls.numeroCiviqueNomRue : this.formGroup.controls.rue;
      const validatorFn = control.validator;
      const errors = validatorFn ? validatorFn(control) : null;
      const estValide = errors === null;
      if (!estValide) {
        this.adresseStreetRef.querySelector('span[slot="error"]').textContent = this.messageErreurRueValide;
      }
      return estValide;
    });

    this.adresseUnitRef.registerCustomValidate(() => {
      const validatorFn = this.formGroup.controls.appartement.validator;
      const errors = validatorFn ? validatorFn(this.formGroup.controls.appartement) : null;
      const estValide = errors === null;
      if (!estValide) {
        this.adresseUnitRef.querySelector('span[slot="error"]').textContent = this.messageErreurAppartementValide;
      }
      return estValide;
    });

    this.adresseCityRef.registerCustomValidate(() => {
      const validatorFn = this.formGroup.controls.ville.validator;
      const errors = validatorFn ? validatorFn(this.formGroup.controls.ville) : null;
      const estValide = errors === null;
      if (!estValide) {
        this.adresseCityRef.querySelector('span[slot="error"]').textContent = this.messageErreurVilleValide;
      }
      return estValide;
    });

    this.adressePcRef.registerCustomValidate(() => {
      const validatorFn = this.formGroup.controls.codePostal.validator;
      const errors = validatorFn ? validatorFn(this.formGroup.controls.codePostal) : null;
      const estValide = errors === null;
      if (!estValide) {
        this.adressePcRef.querySelector('span[slot="error"]').textContent = this.messageErreurPcValide;
      }
      return estValide;
    });
  }

  private hookControlToEventChange(
    control: AbstractControl,
    input: HTMLDsdInputElement | HTMLDsdSelectElement | HTMLDsdComboboxElement,
    messageErreur: string = ''
  ): void {
    const eventName = this.detectEventName(input);
    input.addEventListener(eventName, () => {
      control.setValue(input.value);
      // Remettre le message d'erreur par défaut si le champs est vide (bug DSD lorsqu’on utilise des custom validators)
      if (input.error && !input.value) {
        input.querySelector('span[slot="error"]').textContent = messageErreur;
      } else if (input === this.adressePcRef && input.error) {
        // Par défault dsd-adresse offre un seul message d erreur pour le champs code postal (peu importe si c'est invalide ou vide)
        // Puisque registerCustomValidate ne marche pas avec le code postal, je remet le message d'erreur valide.
        input.querySelector('span[slot="error"]').textContent = this.messageErreurPcValide;
      }
    });
  }

  public utiliserMemeAdresse(value: boolean): void {
    this.formGroup.patchValue({
      utiliserMemeAdresse: value,
      dateChangement: value ? '' : this.formGroup.get('dateChangement')?.value,
    });
    if (!value && this.isBancaire && this.adressePostDatee) {
      this.preRemplirAdressePostdatee();
      this.champsInitialises = false;
    }
    this.cybermetrieCoordonneesService.interactionRadioBoutonCoordonneesBancaire(value);
  }

  public onAddressSelected(event: any): void {
    // Vérifie que l'événement contient bien la propriété 'elements' dans 'detail'.
    // Si ce n'est pas le cas, on quitte la méthode
    if (!event?.detail?.elements) {
      return;
    }
    if (this.adresseContientPlusieursChamps(event)) {
      this.setAdresseValidation(event);
      this.champsInitialises = true;
    }

    const elements = event.detail?.elements;
    const name = event.detail?.name;

    const adresse = {
      street: elements[name + '-street']?.value ?? '',
      unit: elements[name + '-unit']?.value ?? '',
      city: elements[name + '-city']?.value ?? '',
      province: elements[name + '-province']?.value ?? '',
      pc: elements[name + '-pc']?.value ?? '',
      country: elements[name + '-country']?.value ?? '',
    };

    if (this.isBancaire) {
      this.onAddressSelectedBancaire(adresse);
    } else {
      this.onAddressSelectedCredit(adresse);
    }
  }

  public onDateChangement(event: any): void {
    const date = event.detail?.value ?? '';
    this.formGroup.patchValue({ dateChangement: date });
  }

  private adresseContientPlusieursChamps(event: any): boolean {
    return !this.champsInitialises && Object.keys(event.detail.elements).length > 1;
  }

  private onAddressSelectedBancaire(adresse: any): void {
    if (adresse) {
      this.formGroup.patchValue({
        numeroCiviqueNomRue: adresse.street,
        appartement: adresse.unit,
        ville: adresse.city,
        province: adresse.province,
        codePostal: adresse.pc,
        codePays: adresse.country,
      });
    }
  }

  private onAddressSelectedCredit(adresse: any): void {
    if (adresse) {
      this.formGroup.patchValue({
        rue: adresse.street,
        appartement: adresse.unit,
        ville: adresse.city,
        province: adresse.province,
        codePostal: adresse.pc,
      });
    }
  }

  private definirPlageDate(): void {
    const aujourdhui = new Date();
    this.dateMin = aujourdhui.toISOString().split('T')[0];
    const dansUnAn = new Date(aujourdhui);
    dansUnAn.setFullYear(aujourdhui.getFullYear() + 1);
    this.dateMax = dansUnAn.toISOString().split('T')[0];
  }

  private detectEventName(element: HTMLElement): string {
    if (!element?.nodeName) {
      return 'change';
    }

    const nodeName = element.nodeName.toUpperCase();

    switch (nodeName) {
      case 'DSD-INPUT':
        return 'dsdInputChange';
      case 'DSD-SELECT':
        return 'dsdSelectChange';
      case 'DSD-COMBOBOX':
        return 'dsdComboboxSelect';
      default:
        return 'change';
    }
  }

  public preRemplirAdressePostdatee(): void {
    if (this.isBancaire && this.adressePostDatee) {
      const province = this.adressePostDatee.codeSubdivisionPays
        ? (this.adressePostDatee.codeSubdivisionPays.split('-')[1] ?? '')
        : '';
      const numeroCivique = this.adressePostDatee.numeroCivique ?? '';
      const nomRue = this.adressePostDatee.nomRue ?? '';
      const numeroCiviqueNomRue =
        numeroCivique && nomRue ? `${numeroCivique} ${nomRue}` : numeroCivique || nomRue || '';

      this.formGroup.patchValue({
        numeroCiviqueNomRue: numeroCiviqueNomRue,
        appartement: this.adressePostDatee.numeroUnite ?? '',
        ville: this.adressePostDatee.nomMunicipalite ?? '',
        province: province,
        codePostal: this.adressePostDatee.codePostal ?? '',
        codePays: this.adressePostDatee.codePays ?? '',
        dateChangement: this.adressePostDatee.dateDebutUtilisation ?? '',
        utiliserMemeAdresse: false,
      });
    }
  }
}
